import type { ISeoPage } from '@dev-fast/types';

export const LOBBY_SEO_PAGES: ISeoPage[] = [
  {
    countryName: 'Finland',
    countryCode: 'fi',
    routePath: 'best-csgo-site-finland',
    hreflang: 'en-fi',
    titleKey: 'LOBBY.SEO_PAGES.FINLAND.TITLE',
    flagEmoji: '🇫🇮',
  },
  {
    countryName: 'Lithuania',
    countryCode: 'lt',
    routePath: 'best-csgo-site-lithuania',
    hreflang: 'en-lt',
    titleKey: 'LOBBY.SEO_PAGES.LITHUANIA.TITLE',
    flagEmoji: '🇱🇹',
  },
  {
    countryName: 'Portugal',
    countryCode: 'pt',
    routePath: 'best-csgo-site-portugal',
    hreflang: 'en-pt',
    titleKey: 'LOBBY.SEO_PAGES.PORTUGAL.TITLE',
    flagEmoji: '🇵🇹',
  },
  {
    countryName: 'Norway',
    countryCode: 'no',
    routePath: 'best-csgo-site-norway',
    hreflang: 'en-no',
    titleKey: 'LOBBY.SEO_PAGES.NORWAY.TITLE',
    flagEmoji: '🇳🇴',
  },
  {
    countryName: 'Czech',
    countryCode: 'cz',
    routePath: 'best-csgo-site-czech',
    hreflang: 'en-cz',
    titleKey: 'LOBBY.SEO_PAGES.CZECH.TITLE',
    flagEmoji: '🇨🇿',
  },
  {
    countryName: 'Brazil',
    countryCode: 'br',
    routePath: 'best-csgo-site-brazil',
    hreflang: 'en-br',
    titleKey: 'LOBBY.SEO_PAGES.BRAZIL.TITLE',
    flagEmoji: '🇧🇷',
  },
  {
    countryName: 'Poland',
    countryCode: 'pl',
    routePath: 'best-csgo-site-poland',
    hreflang: 'en-pl',
    titleKey: 'LOBBY.SEO_PAGES.POLAND.TITLE',
    flagEmoji: '🇵🇱',
  },
  {
    countryName: 'Latvia',
    countryCode: 'lv',
    routePath: 'best-csgo-site-latvia',
    hreflang: 'en-lv',
    titleKey: 'LOBBY.SEO_PAGES.LATVIA.TITLE',
    flagEmoji: '🇱🇻',
  },
  {
    countryName: 'Germany',
    countryCode: 'de',
    routePath: 'best-csgo-site-germany',
    hreflang: 'en-de',
    titleKey: 'LOBBY.SEO_PAGES.GERMANY.TITLE',
    flagEmoji: '🇩🇪',
  },
  {
    countryName: 'USA',
    countryCode: 'us',
    routePath: 'best-csgo-site-usa',
    hreflang: 'en-us',
    titleKey: 'LOBBY.SEO_PAGES.USA.TITLE',
    flagEmoji: '🇺🇸',
  },
  {
    countryName: 'Georgia',
    countryCode: 'ge',
    routePath: 'best-csgo-site-georgia',
    hreflang: 'en-ge',
    titleKey: 'LOBBY.SEO_PAGES.GEORGIA.TITLE',
    flagEmoji: '🇬🇪',
  },
  {
    countryName: 'Israel',
    countryCode: 'il',
    routePath: 'best-csgo-site-israel',
    hreflang: 'en-il',
    titleKey: 'LOBBY.SEO_PAGES.ISRAEL.TITLE',
    flagEmoji: '🇮🇱',
  },
  {
    countryName: 'Slovakia',
    countryCode: 'sk',
    routePath: 'best-csgo-site-slovakia',
    hreflang: 'en-sk',
    titleKey: 'LOBBY.SEO_PAGES.SLOVAKIA.TITLE',
    flagEmoji: '🇸🇰',
  },
  {
    countryName: 'Romania',
    countryCode: 'ro',
    routePath: 'best-csgo-site-romania',
    hreflang: 'en-ro',
    titleKey: 'LOBBY.SEO_PAGES.ROMANIA.TITLE',
    flagEmoji: '🇷🇴',
  },
  {
    countryName: 'France',
    countryCode: 'fr',
    routePath: 'best-csgo-site-france',
    hreflang: 'en-fr',
    titleKey: 'LOBBY.SEO_PAGES.FRANCE.TITLE',
    flagEmoji: '🇫🇷',
  },
  {
    countryName: 'Australia',
    countryCode: 'au',
    routePath: 'best-csgo-site-australia',
    hreflang: 'en-au',
    titleKey: 'LOBBY.SEO_PAGES.AUSTRALIA.TITLE',
    flagEmoji: '🇦🇺',
  },
];
